import React, { memo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Constant from '../../../../common/constant/Constant';
import { getRichTextFieldContent } from '../../../ticketList/handler/TicketHandler';
import Utils from '@/common/utils/utils';
import { getFileSizeDisplay } from '@/component/common/UploadFiles';
import MermaidDiagram from '@/component/formManagement/fieldUI/MermaidDiagram';
import MarkdownView from '@/component/formManagement/fieldUI/MarkdownView';
import JsonView from '@uiw/react-json-view';
import { JSON_VIEW_STYLE } from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';

function DataFormQaAfterSubmit({ message, getMessage }) {
    const [listFieldInputData, setListFieldInputData] = useState([]);
    const [messageState, setMessagesState] = useState(message);

    // Safe getMessage wrapper with fallback
    const safeGetMessage = key => {
        if (typeof getMessage === 'function') {
            return getMessage(key);
        }
        // Fallback to I18n if getMessage is not available
        return trI18n(key);
    };

    useEffect(() => {
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message);
        }
    }, [message]);

    const getFileUploaded = fileUploadList => {
        if (!fileUploadList || Utils.isEmptyArray(fileUploadList)) return '';
        let valueFileUploaded = '';

        fileUploadList.forEach(file => {
            if (file.file?.name) {
                let defaultFileName = file.file?.name;
                let fileSize = file.file?.size;
                const lastDot = defaultFileName.lastIndexOf('.');
                let fileName;
                let fileExtention;
                if (defaultFileName.substring(0, lastDot).length === 0) {
                    fileName =
                        defaultFileName.length > 50
                            ? defaultFileName.slice(0, 50) + '...'
                            : defaultFileName;
                } else {
                    fileExtention = defaultFileName.substring(lastDot + 1);
                    fileName =
                        defaultFileName.substring(0, lastDot).length > 50
                            ? defaultFileName.substring(0, lastDot).slice(0, 50) + '...'
                            : defaultFileName.substring(0, lastDot) + '.';
                }

                valueFileUploaded = `${valueFileUploaded} \n ${fileName}${fileExtention} (${getFileSizeDisplay(
                    fileSize
                )})`;
            }
        });
        return valueFileUploaded;
    };

    useEffect(() => {
        let formData = messageState.content[0];
        let fieldListData = formData?.fieldListData;
        let formDataTranfer = formData?.formDataTranfer;
        let fileUploadList = formData?.fileUploadList;

        let filedDataResult = [...fieldListData];
        filedDataResult.forEach(field => {
            if (field.type === Constant.FORM_TYPE.FIELD_RICHTEXT) {
                let richTextOriginData = formDataTranfer[field.id];
                // setEditorState(
                //     EditorState.createWithContent(
                //         ContentState.createFromBlockArray(
                //             htmlToDraft(Utils.convertJSONDataToObject(richTextOriginData))
                //         )
                //     )
                // );

                // let richTextValue = formDataTranfer[field.id]?.replace(/(<([^>]+)>)/gi, '').replace(/\\n/g, '');
                // richTextValue = richTextValue.slice(1, -1);
                field.inputValue = richTextOriginData
                    ? Utils.convertJSONDataToObject(richTextOriginData)
                    : '';
            } else if (
                field.type === Constant.FORM_TYPE.FIELD_TEXT &&
                field.structure?.UI === Constant.FIELD_UI.DROP_FILE
            ) {
                field.inputValue = getFileUploaded(fileUploadList);
            } else {
                field.inputValue = formDataTranfer[field.id];
                if (field.structure?.UI === Constant.FIELD_UI.FIELD_RICHTEXT) {
                    let richTextValue = formDataTranfer[field.id]
                        ?.replace(/(<([^>]+)>)/gi, '')
                        .replace(/\\n/g, '');
                    richTextValue = richTextValue.slice(1, -1);
                    field.inputValue = getRichTextFieldContent(richTextValue);
                }
            }
        });
        setListFieldInputData(filedDataResult);
    }, [messageState.content[0].formDataTranfer]);
    return (
        <div
            className={
                messageState.isMaximizedPanel ? 'message-text maximized-form-text' : 'message-text'
            }
        >
            {messageState.anonymousType === Constant.ANONYMOUS_TYPE.CHATBOT && (
                <>
                    <div className="label-title">{safeGetMessage('form_email_label')}</div>
                    <div>{messageState.content[0].formDataTranfer.mailAddress}</div>
                    <div>
                        <div className="label-title">{safeGetMessage('form_name_label')}</div>
                        <div>{`${
                            messageState.content[0].formDataTranfer.lastName
                                ? messageState.content[0].formDataTranfer.lastName
                                : ''
                        } ${
                            messageState.content[0].formDataTranfer.firstName
                                ? messageState.content[0].formDataTranfer.firstName
                                : ''
                        }`}</div>
                    </div>
                    <div>
                        <div className="label-title">{safeGetMessage('form_name_kana_label')}</div>
                        <div>{`${
                            messageState.content[0].formDataTranfer.lastNameKana
                                ? messageState.content[0].formDataTranfer.lastNameKana
                                : ''
                        } ${
                            messageState.content[0].formDataTranfer.firstNameKana
                                ? messageState.content[0].formDataTranfer.firstNameKana
                                : ''
                        }`}</div>
                    </div>
                </>
            )}
            {!Utils.isEmptyArray(listFieldInputData) &&
                listFieldInputData.map((item, index) => (
                    <>
                        {![
                            Constant.FORM_TYPE.FIELD_TAG,
                            Constant.FORM_TYPE.FIELD_RICHTEXT,
                            Constant.FORM_TYPE.FIELD_WORKFLOW,
                            Constant.FORM_TYPE.MERMAID,
                            Constant.FORM_TYPE.HTML,
                            Constant.FORM_TYPE.MARKDOWN,
                            Constant.FORM_TYPE.JSON
                        ].includes(item?.type) && (
                            <>
                                {item.sysField === 'attachments' ? (
                                    <div key={index}>
                                        <div className="label-qa label-qa-attactment">
                                            {Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            )}
                                        </div>
                                        <div>
                                            {messageState.content[0].fileUploadList?.map(
                                                (fileAtt, indexFile) => (
                                                    <div key={indexFile}>{fileAtt.file?.name}</div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div key={index} className="label-qa">
                                        <div>
                                            {Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            )}
                                        </div>
                                        <td>{item.inputValue}</td>
                                    </div>
                                )}
                            </>
                        )}

                        {item.type === Constant.FORM_TYPE.FIELD_TAG && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div>
                                    {item.inputValue?.map((tagItem, indexTag) => (
                                        <div key={indexTag}>{tagItem.title}</div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {item.type === Constant.FORM_TYPE.MERMAID && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div>
                                    <MermaidDiagram
                                        code={item.inputValue}
                                        id={`${item.id}_${messageState.idMessage}`}
                                    />
                                </div>
                            </div>
                        )}

                        {item.type === Constant.FORM_TYPE.FIELD_RICHTEXT && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: item.inputValue
                                        }}
                                        // dangerouslySetInnerHTML={{
                                        //     __html: draftToHtml(
                                        //         convertToRaw(editorState.getCurrentContent())
                                        //     )
                                        // }}
                                    ></div>
                                </div>
                            </div>
                        )}

                        {item.type === Constant.FORM_TYPE.HTML && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div>
                                    {!item?.inputValue ? (
                                        <div
                                            style={{
                                                overflowY: 'auto',
                                                width: '100%',
                                                height: '500px',
                                                minHeight: '500px',
                                                border: '1px solid #C7CAD1',
                                                borderRadius: '6px',
                                                backgroundColor: '#F2F3F5'
                                            }}
                                        ></div>
                                    ) : (
                                        <iframe
                                            title="html-content"
                                            style={{
                                                overflowY: 'auto',
                                                width: '100%',
                                                height: '500px',
                                                minHeight: '500px',
                                                border: '1px solid #C7CAD1',
                                                borderRadius: '6px',
                                                backgroundColor: 'white'
                                            }}
                                            srcDoc={item?.inputValue}
                                        />
                                    )}
                                </div>
                            </div>
                        )}

                        {item.type === Constant.FORM_TYPE.MARKDOWN && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div>
                                    <MarkdownView
                                        content={item?.inputValue || ''}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}

                        {item.type === Constant.FORM_TYPE.JSON && (
                            <div key={index} className="label-qa">
                                <div>
                                    {Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name)}
                                </div>
                                <div className={'json-render json-disabled'}>
                                    {item?.inputValue
                                        ? (() => {
                                              try {
                                                  const parsed = JSON.parse(item.inputValue);
                                                  return (
                                                      <JsonView
                                                          value={parsed}
                                                          collapsed={2}
                                                          enableClipboard={false}
                                                          displayDataTypes={false}
                                                          style={JSON_VIEW_STYLE}
                                                      />
                                                  );
                                              } catch {
                                                  return <pre>{item.inputValue}</pre>;
                                              }
                                          })()
                                        : null}
                                </div>
                            </div>
                        )}
                    </>
                ))}
        </div>
    );
}
export default memo(DataFormQaAfterSubmit);
